import { RESUMEQUEUE_TASK, RESUMEQUEUE_TASK_SUCCESSFUL, RESUMEQUEUE_TASK_FAILED } from './actionTypes';

const initialState = {
    resumeQueueError: null, messageTask: null, loadingUpdateTask: false
}

const resumeQueueTask = (state = initialState, action) => {
    switch (action.type) {
        case RESUMEQUEUE_TASK:
            state = {
                ...state,
                loadingUpdateTask: true,
                resumeQueueError: null
            }
            break;
        case RESUMEQUEUE_TASK_SUCCESSFUL:
            state = {
                ...state,
                loadingUpdateTask: false,
                messageTask: action.payload,
                resumeQueueError: null
            }
            break;
        case RESUMEQUEUE_TASK_FAILED:
            state = {
                ...state,
                messageTask: null,
                loadingUpdateTask: false,
                resumeQueueError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default resumeQueueTask;